module.exports = __webpack_public_path__ + "img/banner.c6596bd8.png";